module.exports = __webpack_public_path__ + "img/img5.e6e2a691.png";